import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginCredentials } from '../../../core/models/user.model';
import { AuthService } from '../../../core/services/auth.service';
import { CargoService } from '../../../core/services/cargo.service';
import { MeuLocalService } from '../../../core/services/meu-local.service';
import { MeuLocalDialogComponent } from '../../meu-local/meu-local-dialog.component';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatInputModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatCheckboxModule
  ],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  loginForm: FormGroup;
  showPassword = false;
  isLoading = false;
  loginError: string | null = null;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private cargoService: CargoService,
    private meuLocalService: MeuLocalService,
    private dialog: MatDialog
  ) {
    this.loginForm = this.fb.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]],
      remember: [false]
    });

    if (this.route.snapshot.queryParamMap.get('expirado') === '1') {
      this.loginError = 'Sua sessão expirou. Faça login novamente.';
    }
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  onSubmit(): void {
    if (this.loginForm.valid) {
      this.isLoading = true;
      this.loginError = null;
      const credentials: any = {
        username: this.loginForm.value.username,
        password: this.loginForm.value.password
      };
      this.authService.login(credentials).pipe(
        catchError((err) => {
          this.loginError = 'Usuário ou senha inválidos';
          this.isLoading = false;
          return of(null);
        })
      ).subscribe((res) => {
        this.isLoading = false;
        if (res && res.token) {
          localStorage.setItem('token', res.token);
          if (res.user) {
            localStorage.setItem('user', JSON.stringify(res.user));
          }
          // Atualiza o cache de cargos a cada login (não bloqueia a navegação)
          this.cargoService.loadCargos().subscribe({ error: () => {} });

          // Se o usuário ainda não definiu seu local, oferece a escolha (com opção de pular)
          if (!this.meuLocalService.meuLocal) {
            this.dialog.open(MeuLocalDialogComponent, { width: '480px', disableClose: false })
              .afterClosed().subscribe(() => this.router.navigate(['/event-manager']));
          } else {
            this.router.navigate(['/event-manager']);
          }
        } else if (!this.loginError) {
          this.loginError = 'Usuário ou senha inválidos';
        }
      });
    }
  }
}
